export const FlowEnum = Object.freeze({
  OUTSIDEPARKINGAPP: "outsideparkingapp",
  STANDARDFLOW: "standardflow",
  STANDARDRECEIPT: "standardreceipt",
  AMENDMENTFLOW: "amendment",
  AMENDMENTFLOWEDITTIME: "amendmentedittime",
  AMENDMENTFLOWCHANGECARPARK: "amendmentchangecarpark",
  AMENDMENTCHECKOUT: "amendmentcheckout",
  AMENDMENTRECEIPT: "amendmentreceipt",
  EXTENDFLOW: "extendflow",
  EXTENDEDITTIME: "extendedittime",
  EXTENDCHECKOUT: "extendcheckout",
  EXTENDRECEIPT: "extendreceipt",
})
